<template>
  <v-carousel
    hide-delimiters
  >
    <v-carousel-item
      v-for="(leader) in leaders"
      :key="leader.id"
    >
      <v-sheet
        height="100%"
        tile
      >
        <v-row
          class="fill-height"
          align="center"
          style="justify-content: space-evenly;"
        >
          <leadership-card
            v-bind:leader="leader"
            :corner="'bottom-left'"
            :mediumScreen="mediumScreen"
          ></leadership-card>

          <quote-card
            v-show="mediumScreen"
            :quote="leader.quote"
            :title="leader.fullName"
            :subtitle="leader.title"
          ></quote-card>

        </v-row>
      </v-sheet>
    </v-carousel-item>

    <triangle-div
      corner="bottom-right"
      borderBottom="50px solid #00B1C3"
      borderLeft="180px solid transparent"
      borderRight="0px solid transparent"
      width="100px"
    ></triangle-div>

  </v-carousel>
</template>

<script>
import LeadershipCard from '@/components/leadership/LeadershipCard.vue'
import QuoteCard from '@/components/leadership/QuoteCard.vue'
import TriangleDiv from '../TriangleDiv.vue'

export default {
    components: {
      'leadership-card': LeadershipCard,
      'quote-card': QuoteCard,
      'triangle-div': TriangleDiv
    },
    name: "LeadershipCarousel",
    /**
     * An array of objects that contain information
     * about individuals.
     */
    props: {
        leaders: Array,
        default: []
    },
    computed: {
      mediumScreen () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return false
          case 'sm': return false
          case 'md': return true
          case 'lg': return true
          case 'xl': return true
          default: return false
        }
      },
    },
}
</script>